import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest, select, call } from "redux-saga/effects";
import { getIntegracaoWhatsapp } from "../../crud/inicio.crud";

export const actionTypes = {
    PhoneRequested: "[Request Phone] Action",
    PhoneLoaded: "[Load Phone] API",
    PhoneReset: "[Reset Phone] Clear Data",
};

const initialConfigState = {
    phoneNumber: undefined,
    lastFetched: undefined,
};

export const reducer = persistReducer({ storage, key: "app-config", whitelist: ["phoneNumber", "lastFetched"] }, (state = initialConfigState, action) => {
    switch (action.type) {
        case actionTypes.PhoneLoaded: {
            return {
                ...state,
                phoneNumber: action.payload.phoneNumber,
                lastFetched: action.payload.lastFetched,
            };
        }
        case actionTypes.PhoneReset: {
            return initialConfigState;
        }
        default:
            return state;
    }
});

export const actions = {
    requestPhone: () => ({ type: actionTypes.PhoneRequested }),
    fulfillPhone: (payload) => ({ type: actionTypes.PhoneLoaded, payload }),
    resetPhone: () => ({ type: actionTypes.PhoneReset }),
};

export function* saga() {
    yield takeLatest(actionTypes.PhoneRequested);
}
